import { Component, OnInit } from '@angular/core';
import { LoginService } from './services/login.service';

@Component({
	selector: 'dx-root',
	template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
	title = 'DXCompliance';

	constructor(private loginService: LoginService) {}

	ngOnInit(): void {}
}
